'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var Checkbox = _interopDefault(require('@material-ui/core/Checkbox'));
var styledComponents = require('./styled-components.js');

var InputCheckbox = function (props) {
    var _a = props.value, value = _a === void 0 ? 'checked' : _a, _b = props.disabled, disabled = _b === void 0 ? false : _b, _c = props.initiallyChecked, initiallyChecked = _c === void 0 ? false : _c, _d = props.label, label = _d === void 0 ? '' : _d, _e = props.onChange, onChange = _e === void 0 ? function () { } : _e, _f = props.onLabelClick, onLabelClick = _f === void 0 ? function () { } : _f, _g = props.onLabelFocus, onLabelFocus = _g === void 0 ? function () { } : _g, _h = props.controlled, controlled = _h === void 0 ? false : _h, _j = props["data-testid"], dataTestId = _j === void 0 ? 'checkbox' : _j;
    var _k = React.useState(initiallyChecked), currentCheck = _k[0], setCheck = _k[1];
    var handleChange = function (event) {
        setCheck(event.target.checked);
        onChange(event.target.checked, event);
    };
    return (React__default.createElement(styledComponents.StyledFormControlLabel, { onClick: onLabelClick, onFocus: onLabelFocus, control: React__default.createElement(Checkbox, { onChange: handleChange, checked: controlled ? initiallyChecked : currentCheck, disabled: disabled, value: value, color: 'primary', "data-testid": dataTestId }), label: label }));
};

module.exports = InputCheckbox;
